import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { useTheme } from '@mui/material/styles';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { StyledCodeBlockContainer, StyledCopyButton } from './CodeBlock.styled';
import { useCopyHandler } from '../../hooks/useCopyHandler';

interface CodeBlockProps {
  language: string;
  value: string;
};

const CodeBlock: React.FC<CodeBlockProps> = ({ language, value }) => {
  const theme = useTheme();
  const syntaxStyle = theme.palette.mode === 'dark' ? oneDark : prism;
  const { copied, handleCopy } = useCopyHandler(value);
  

  return (
    <StyledCodeBlockContainer>
       <StyledCopyButton onClick={handleCopy}>
        {copied ? 'Kopiert!' : 'Kopieren'}
      </StyledCopyButton>
      <SyntaxHighlighter language={language} style={syntaxStyle}>
        {value}
      </SyntaxHighlighter>
    </StyledCodeBlockContainer>
  );
};

export default CodeBlock;